import { MAT_DATE_FORMATS } from '@angular/material/core';



export const MY_DATE_FORMATS = {
    parse: {
      dateInput: 'MMM YYYY',
    },
    display: {
      dateInput: 'MM/YYYY',
      monthYearLabel: 'MMM YYYY',
      dateA11yLabel: 'LL',
      monthYearA11yLabel: 'MMMM YYYY',
    },
  };
